import { isX } from '../typeGuards/Channel';
export const STRATEGY_FLAT = {
  strategy: 'flat'
};
const STRATEGY_ROTATE = {
  labelAngle: 40,
  strategy: 'rotate'
};
export default function expandLabelOverlapStrategy(channelType, labelOverlap = 'auto') {
  let output;

  switch (labelOverlap) {
    case 'flat':
      output = STRATEGY_FLAT;
      break;

    case 'rotate':
      output = STRATEGY_ROTATE;
      break;

    case 'auto':
      output = isX(channelType) ? STRATEGY_ROTATE : STRATEGY_FLAT;
      break;

    default:
      output = labelOverlap;
      break;
  }

  return { ...output
  };
}